import React, { useState } from "react"
import PropTypes from "prop-types"
import Image from "../Image/Image"
import { imageConstants } from "../../../constants/image.constants"
import VideoModal from "../../ArticleVideo/VideoModal/VideoModal"
import Button from "../Button/Button"

const ModalView = props => {
  const { poster, videoLink, isIframe, title } = props
  const [isModalOpen, setIsModalOpen] = useState(false)
  return (
    <>
      <Button
        onClick={() => {
          setIsModalOpen(true)
        }}
      >
        <Image src={poster} />
        <Image
          contentfulImage={imageConstants.playBtn}
          className={"bg-lightGray"}
        />
      </Button>

      {isModalOpen && (
        <VideoModal
          isModalOpen={isModalOpen}
          closeVideoModal={() => {
            setIsModalOpen(false)
          }}
          isIframe={isIframe}
          src={videoLink}
          title={title}
        />
      )}
    </>
  )
}

ModalView.propTypes = {
  poster: PropTypes.string,
  videoLink: PropTypes.string,
  isIframe: PropTypes.bool,
  title: PropTypes.string,
}

export default ModalView
